import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';

import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button/';
import { LabeledInfo } from 'ui-components/components/labeled-info-list/labeled-info';

import messages from '../../messages';
import styles from '../styles.module.less';

const TrackingLinks = ({ data: trackingLinks }) => {
  const intl = useIntl();
  return (
    <LabeledInfo
      label={intl.formatMessage(messages.tracking, {
        count: trackingLinks.length,
      })}
    >
      {trackingLinks.map((trackingLink) => (
        <Button key={trackingLink.trackingNumber} href={trackingLink.trackingUrl} target='_blank' theme='link'>
          {trackingLink.trackingNumber}
          <FontAwesomeIcon className={styles['tracking-link-icon']} icon={faExternalLinkAlt} />
        </Button>
      ))}
    </LabeledInfo>
  );
};

TrackingLinks.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      trackingNumber: PropTypes.string.isRequired,
      trackingUrl: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default TrackingLinks;
